// Utilitários de máscara (formatação) para campos cadastrais.
// Funções puras, sem dependência externa.

/** Remove tudo que não for dígito. */
export const onlyDigits = (value: string): string => value.replace(/\D/g, '');

/** Formata CNPJ: 00.000.000/0000-00 (aplica progressivamente conforme digitação). */
export const maskCNPJ = (value: string): string => {
  const digits = onlyDigits(value).slice(0, 14);
  return digits
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
};

/** Formata CEP: 00000-000. */
export const maskCEP = (value: string): string => {
  const digits = onlyDigits(value).slice(0, 8);
  return digits.replace(/^(\d{5})(\d)/, '$1-$2');
};

/** Formata telefone/celular: (00) 0000-0000 ou (00) 00000-0000 (aplica progressivamente). */
export const maskTelefone = (value: string): string => {
  const digits = onlyDigits(value).slice(0, 11);
  return digits
    .replace(/^(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{4,5})(\d{4})$/, '$1-$2');
};
